module.exports = __webpack_public_path__ + "static/media/scanner_zone.d409c40d.png";